import styled from "styled-components";

export const ErrorModalBackground = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  backdrop-filter: blur(3px);
  background-color: rgba(73, 73, 73, 0.3);
  cursor: pointer;
`

export const ErrorModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  max-width: 800px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 15px;
  padding: 20px;
  color: #2E3A59;

  @media (min-width: 651px) {
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 650px) {
    left: 5%;
    transform: translate(-2.5%, -50%);
  }
`

export const ErrorModalCloseIcon = styled.i`
  display: flex;
  align-self: flex-end;
  margin-right: 15px;
  font-size: 30px;
  color: var(--color-navigation);
  cursor: pointer;
`

export const ErrorModalTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const ErrorModalHeader = styled.h1`
  color: var(--color-secondary-text);
  font-size: var(--font-size-l);
  font-weight: var(--font-weight-normal);
  margin: 20px 0;
`

export const ErrorModalIconWrapper = styled.div`
  display: flex;
  height: 120px;
  width: 120px;
  border-radius: 50%;
  background-color: var(--color-primary);
  justify-content: center;
  align-items: center;
`

export const ErrorModalIconOutline = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: solid 5px white;
`

export const ErrorModalIcon = styled.i`
  color: white;
  font-size: var(--font-size-xl);
`

export const ErrorModalErrorText = styled.p`
  color: var(--color-secondary-text);
  font-size: var(--font-size-sm);
  width: 75%;
  margin: 20px 0;
`

export const ErrorModalButtonContainer = styled.div`
  background-color: var(--color-primary);
  margin: 20px 0;
  padding: 15px 30px;
  color: white;
  border-radius: 10px;
  width: 40%;
  cursor: pointer;
`

export const ErrorModalButtonText = styled.p`
  font-weight: bold;
`